import { render } from "./MenuModal.vue?vue&type=template&id=34fb05a9&scoped=true"
import script from "./MenuModal.vue?vue&type=script&lang=js"
export * from "./MenuModal.vue?vue&type=script&lang=js"

import "./MenuModal.vue?vue&type=style&index=0&id=34fb05a9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34fb05a9"]])

export default __exports__